import { DEFAULT_CURRENCY_CODE } from '@angular/core';
import { isValidCurrency } from 'shared/framework/util/javascript';

export const FALLBACK_CURRENCY_CODE = 'EUR';

export const provideCurrency = (currency?: string) => ({
    provide: DEFAULT_CURRENCY_CODE,
    useValue: isValidCurrency(currency) ? currency : FALLBACK_CURRENCY_CODE,
});
